import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b9e2fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewHeader" }
const _hoisted_2 = {
  class: "relative",
  ref: "searchref"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "flex"
}
const _hoisted_5 = { class: "flex items-center w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_7 = {
  class: "relative",
  ref: "elementref"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_header_search_suggestions = _resolveComponent("header-search-suggestions")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_header_profile = _resolveComponent("header-profile")!
  const _component_header_profile_dropdown = _resolveComponent("header-profile-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_input, {
        placeholder: "Поиск накладной",
        value: _ctx.search_state.query,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_state.query) = $event)),
        "is-invalid": _ctx.search_state.is_failed,
        onInput: _ctx.searchSuggestions
      }, {
        "icon-left": _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["value", "is-invalid", "onInput"]),
      _withDirectives(_createVNode(_component_header_search_suggestions, {
        loading: _ctx.search_state.is_loading,
        failed: _ctx.search_state.is_failed,
        suggestions: _ctx.search_state.suggestions
      }, null, 8, ["loading", "failed", "suggestions"]), [
        [_vShow, Boolean(_ctx.search_state.query)]
      ])
    ], 512),
    (_ctx.state.is_in_tms_routes && _ctx.havePermissions(['tms.pre-trip-complete-day-status']))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_new_button, {
            type: "button",
            class: _normalizeClass(["NewHeader__complete-tms-day-button", { 'NewButton--danger': !_ctx.complete_tms_day_state.is_can_complete }]),
            disabled: _ctx.complete_tms_day_state.is_loading,
            loading: _ctx.complete_tms_day_state.is_loading,
            onClick: _ctx.onCompleteTmsDay
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Завершить рабочий день ")
            ]),
            _: 1
          }, 8, ["disabled", "loading", "class", "onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isSectorsVisible && !_ctx.withoutSectors)
        ? (_openBlock(), _createBlock(_component_new_select, {
            key: 0,
            class: "w-full",
            "nullable-option": _ctx.isNullableOption,
            "nullable-text": "Все секторы",
            "custom-option": _ctx.isCustomOption,
            "custom-value": 999999,
            "is-custom-checked": _ctx.state.is_custom_checked,
            "custom-text": "Без сектора",
            value: _ctx.new_dispatcher_store.dispatcherSectorIds,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.new_dispatcher_store.dispatcherSectorIds) = $event)),
            placeholder: "Сектор диспетчера",
            loading: _ctx.data_state.dispatcher_sectors.is_loading,
            failed: _ctx.data_state.dispatcher_sectors.is_failed,
            "error-text": "Произошла ошибка",
            options: _ctx.data_state.dispatcher_sectors.list,
            "search-without-refresh": "",
            "is-invalid": 
                    (!_ctx.new_dispatcher_store.dispatcherSectorIds ||
                        !_ctx.new_dispatcher_store.dispatcherSectorIds.length) &&
                    !_ctx.isNullableOption
                ,
            multiselect: "",
            onRefresh: _ctx.loadDispatcherSectors,
            onChange: _ctx.onDispatcherSectorsChange,
            onSelectCustom: _ctx.onSelectCustom
          }, null, 8, ["nullable-option", "custom-option", "is-custom-checked", "value", "loading", "failed", "options", "is-invalid", "onRefresh", "onChange", "onSelectCustom"]))
        : _createCommentVNode("", true),
      (_ctx.isSectorsVisible && !_ctx.withoutSectors)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            disabled: _ctx.state.is_loading,
            class: "NewButton--reset ml-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDispatcherSectorsChange([])))
          }, {
            "icon-left": _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_header_profile, { onClick: _ctx.toggleHeaderDropdown }, null, 8, ["onClick"]),
      (_ctx.state.is_header_dropdown_opened)
        ? (_openBlock(), _createBlock(_component_header_profile_dropdown, { key: 0 }))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}